export default function Sparkline({ data, color = "primary", height = 40 }) {
    if (!data?.length) return null;
    const w = 120, h = height;
    const min = Math.min(...data), max = Math.max(...data);
    const range = max - min || 1;
    const pts = data.map((v, i) => {
      const x = (i / (data.length - 1)) * w;
      const y = h - ((v - min) / range) * (h - 4) - 2;
      return `${x},${y}`;
    }).join(" ");
    return (
      <svg width={w} height={h} className="sparkline">
        <polyline points={pts} className={`sparkline__path sparkline__path--${color}`} />
      </svg>
    );
  }